import React, { useState } from "react";
import ApiData from "../../api/ApiData";
import { CcV4Toggle } from "../UI/CcV4Toggle";
import { InputEditVer1 } from "../UI/InputEditVer1";
import User from "../../api/User";
import { BtnOutlineV4 } from "../UI/button/BtnOutlineV4";
export const NumberCompany = () => {
  const [valueNumber, setValueNumber] = useState(
    ApiData.company.number_company,
  );
  const [upDateNumberBlock, setUpDateNumberBlock] = useState(false);
  const [showEditNumber, setShowEditNumber] = useState(false);

  const canEdit =
    User.user.permission.includes("patch_company") || User.user.is_superuser;

  const updateUrNumberFunc = async () => {
    if (valueNumber <= 0) {
      return alert("Номер компании не может быть ниже нуля");
    }
    if (valueNumber > 1) {
      const res = await ApiData.updateUrNumber(valueNumber);
      if (res) {
        setUpDateNumberBlock(false);
        setShowEditNumber(false);
      }
    } else {
      const res = await ApiData.updateUrNumber(1);
      if (res) {
        setUpDateNumberBlock(false);
        setShowEditNumber(false);
      }
    }
  };

  if (ApiData.company.number_company === 1) {
    if (!upDateNumberBlock) {
      return (
        <div className="num-company-control">
          <div className="num-company-text">
            <div className="num-company-title">Работа с несколькими юр. лицами</div>
            <div className="num-company-meta">
              Работа с несколькими юридическими лицами выключена
            </div>
          </div>
          {canEdit ? (
            <CcV4Toggle
              active={false}
              onClick={() => setUpDateNumberBlock(true)}
            />
          ) : null}
        </div>
      );
    }

    return (
      <div className="num-company-control num-company-control-edit">
        <div className="num-company-text">
          <div className="num-company-title">Работа с несколькими юр. лицами</div>
          <div className="num-company-meta">
            Укажите количество компаний, с которыми работает организация
          </div>
        </div>
        <div className="num-company-actions">
          <input
            className="form-control num-company-input"
            type="number"
            value={valueNumber}
            onChange={(e) => setValueNumber(e.target.value)}
            placeholder="2"
            min="2"
          />
          <button
            type="button"
            className="btn-primary-v4"
            onClick={updateUrNumberFunc}
          >
            Подтвердить
          </button>
          <BtnOutlineV4
            onClick={() => setUpDateNumberBlock(false)}
            text="Отмена"
          />
        </div>
      </div>
    );
  }

  if (!showEditNumber) {
    return (
      <div className="num-company-control">
        <div className="num-company-text">
          <div className="num-company-title">Работа с несколькими юр. лицами</div>
          <div className="num-company-meta">
            Кол-во компаний:{" "}
            <strong className="company-card-v4-mono">
              {ApiData.company.company.number_company}
            </strong>
          </div>
        </div>
        {canEdit ? (
          <BtnOutlineV4
            className="num-company-edit-btn"
            onClick={() => setShowEditNumber(true)}
            text="Изменить"
          />
        ) : null}
      </div>
    );
  }

  return (
    <div className="num-company-control num-company-control-edit">
      <div className="num-company-text">
        <div className="num-company-title">Работа с несколькими юр. лицами</div>
        <div className="num-company-meta">Введите новое количество</div>
      </div>
      <div className="num-company-actions">
        <InputEditVer1
          value={valueNumber}
          onChange={(e) => setValueNumber(e.target.value)}
          style={{ width: "64px" }}
          type="number"
        />
        <button
          type="button"
          className="btn-primary-v4"
          onClick={updateUrNumberFunc}
        >
          Применить
        </button>
        <BtnOutlineV4
          onClick={() => setShowEditNumber(false)}
          text="Отмена"
        />
      </div>
    </div>
  );
};
